/**
 * Pro: Kadence Pro License Inputs
 */
const { addQueryArgs } = wp.url;
const { apiFetch } = wp;
/**
 * Internal block libraries
 */
import map from 'lodash/map';
const { __ } = wp.i18n;
const {
	Component,
	Fragment,
} = wp.element;
const {
	PanelBody,
	TextControl,
	Button,
	Panel,
	Spinner,
	ToggleControl,
	SelectControl,
	ExternalLink,
} = wp.components;
/**
 * Build the Measure controls
 * @returns {object} Measure settings.
 */
class ProModules extends Component {
	constructor() {
		super( ...arguments );
		this.saveConfig = this.saveConfig.bind( this );
		this.state = {
			settings: ( kadenceProDashboardParams.settings ? JSON.parse( kadenceProDashboardParams.settings ) : {} ),
			isSaving: false,
		};
	}
	saveConfig( addonID, settingToggle ) {
		this.setState( { isSaving: addonID } );
		const config = ( kadenceProDashboardParams.settings ? JSON.parse( kadenceProDashboardParams.settings ) : {} );
		if ( ! config[ addonID ] ) {
			config[ addonID ] = {};
		}
		config[ addonID ] = settingToggle;
		const settingModel = new wp.api.models.Settings( { kadence_pro_theme_config: JSON.stringify( config ) } );
		settingModel.save().then( response => {
			this.setState( { isSaving: false, settings: config, isOpen: false } );
			kadenceProDashboardParams.settings = JSON.stringify( config );
		} );
	}
	render() {
		const { list, listsLoaded, isFetching, isSavedAPI, listAttr, isFetchingAttributes, listAttrLoaded, isFetchingGroups, listGroups, listGroupLoaded } = this.state;
		const headerLinks = [
			{
				title: __( 'Header Addons', 'kadence' ),
				description: __( 'Adds elements to the header builder.', 'kadence' ),
				focus: 'kadence_customizer_header',
				type: 'panel',
				setting: 'header_addons',
			},
			{
				title: __( 'Hooked Elements', 'kadence' ),
				description: __( 'Add content anywhere into your site conditionally.', 'kadence' ),
				// focus: 'kadence_customizer_header',
				// type: 'panel',
				setting: 'elements',
			},
			{
				title: __( 'Woocommerce Addons', 'kadence' ),
				description: __( 'Adds new Options into the customizer for woocommerce', 'kadence' ),
				focus: 'kadence_customizer_header',
				type: 'panel',
				setting: 'woocommerce_addons',
			},
		];
		return (
			<Fragment>
				<h2 className="section-header">{ __( 'Pro Addons', 'kadence' ) }</h2>
				<div className="two-col-grid">
					{ map( headerLinks, ( link ) => {
						const enabled = ( this.state.settings && undefined !== this.state.settings[link.setting] ? this.state.settings[link.setting] : false );
						return (
							<div className="link-item">
								<h4>{ link.title }</h4>
								<p>{ link.description }</p>
								<div className="link-item-foot">
									{ enabled && (
										<a href={ `${kadenceProDashboardParams.adminURL}customize.php?autofocus%5B${ link.type }%5D=${ link.focus }` }>
											{ __( 'Customize', 'kadence') }
										</a>
									) }
									{ link.setting && (
										<Fragment>
											<div class="spacer"></div>
											{ this.state.isSaving && this.state.isSaving === link.setting && (
												<Spinner />
											) }
											<ToggleControl
												checked={ enabled }
												onChange={ ( value ) => this.saveConfig( link.setting, value ) }
											/>
										</Fragment>
									) }
								</div>
							</div>
						);
					} ) }
				</div>
			</Fragment>
		);
	}
}
export default ( ProModules );